// extracted by mini-css-extract-plugin
module.exports = {"picture":"img-module__picture___wiM80","image":"img-module__image___Kpwp0"};